// Converts the responsive_url to URL that points directly to the asset in S3.
export function vscoImageResponsiveUrltoS3Path(url) {
    const segments = new URL(url).pathname.split("/");
    const partialUrl = segments.slice(2).join("/");
    return `https://image-${segments[1]}.vsco.co/${partialUrl}`;
}
// fetches the specified media object in order to access its responsive_url property
async function fetchMedia(mediaID) {
    try {
        const resp = await fetch(`https://vsco.co/api/2.0/medias/${mediaID}`, {
            method: "GET",
            credentials: "same-origin",
            headers: {
                authorization: "Bearer 7356455548d0a1d886db010883388d08be84d0c9",
            },
        });
        const result = await resp.json();
        return result.media;
    }
    catch (err) {
        console.error("[fetchMedia] err: ", err);
    }
}
export async function getMediaS3ImageUrl(mediaID) {
    const media = await fetchMedia(mediaID);
    if (!media) {
        return;
    }
    const s3Path = vscoImageResponsiveUrltoS3Path(media.responsive_url);
    return s3Path;
}
// fetches the specified media object in order to access its responsive_url property
async function fetchSiteImage(siteId) {
    try {
        const resp = await fetch(`https://vsco.co/api/2.0/sites/${siteId}`, {
            method: "GET",
            credentials: "same-origin",
            headers: {
                authorization: "Bearer 7356455548d0a1d886db010883388d08be84d0c9",
            },
        });
        const result = await resp.json();
        return result.site;
    }
    catch (err) {
        console.error("[fetchMedia] err: ", err);
    }
}
export async function getSiteS3ImageUrl(siteId) {
    const site = await fetchSiteImage(siteId);
    if (!site) {
        return;
    }
    const s3Path = vscoImageResponsiveUrltoS3Path(site.responsive_url);
    return s3Path;
}
